import { CreateAdmin } from "../../../users/userTypes"
import { UserType } from "../../../login/loginTypes"
import { CompanyAdminsQuery } from "../../../company/admin/account/administrators/adminsApi"
import { MerchantQuery } from "../../../merchant/admin/merchantAdminApi"
import { SupplierAdminsQuery } from "../../../supplier/admin/account/administrators/supplierAdminApi"

type getInvalidateAdminQueryKeyArgs = Pick<CreateAdmin, "type">

export function getInvalidateQueryKey({ type }: getInvalidateAdminQueryKeyArgs) {
    switch (type) {
        case UserType.OFFICE_MANAGER:
            return "admins-for-tenant"
        case UserType.MERCHANT:
            return MerchantQuery.ADMINS_FOR_MERCHANT
        case UserType.COMPANY:
            return CompanyAdminsQuery.ADMINS_FOR_COMPANY
        case UserType.SUPPLIER:
            return SupplierAdminsQuery.ADMINS_FOR_SUPPLIER
        case UserType.SUPPORT:
            return "admins-for-support"
    }
}
